// Function to generate a full URL for an image size
export const generateShopifyImageUrl = (baseUrl, size) => {
  const versionIndex = baseUrl.indexOf('?');
  const path = baseUrl.substring(0, versionIndex);
  const version = baseUrl.substring(versionIndex);
  const lastDotIndex = path.lastIndexOf('.');
  const pathWithoutExtension = path.substring(0, lastDotIndex);
  const extension = path.substring(lastDotIndex);

  return `${pathWithoutExtension}_${size}x${extension}${version}`;
};